import type { App } from 'vue';
import { createPinia } from "pinia";
import { pluginTasksStore } from "@/store/tasksStore";
import { pluginProjectsStore } from "@/store/projectsStore";
import { useCustomFieldsStore } from "@nextories/vue-core-components/src/store/customFieldsStore";
import { pluginMeetingStore } from "@/store/meetingStore";
import { pluginEstimateStore } from "@/store/estimateStore";
import configStore from "@nextories/vue-core-components/src/utils/helpers/configStore";

// Create and export Pinia
export const pinia = createPinia();

export default {
  pluginStore: {
    tasks: pluginTasksStore,
    projects: pluginProjectsStore,
    estimate: pluginEstimateStore,
    meeting: pluginMeetingStore,
  },
  install(app: App) {
    // Set state and actions in store pinia
    // tasks
    // projects
    // estimate
    // meeting
    pinia.use(({ store }) => {
      if (store) {
        const plugin = this.pluginStore[store.$id];
        if (plugin) {
          const customFieldsStore = store.$id === "projects" || store.$id === "meeting"
            ? JSON.parse(JSON.stringify(useCustomFieldsStore().$state)) : undefined;
          configStore.updateStoreStateAndActions(
            store,
            plugin,
            customFieldsStore,
          );
        }
      }
    });
    app.use(pinia);
  },
};
